<template>
    <div class="look-detail">
        <div class="look-title">
            {{ lookDetail.title }}
        </div>
        <div class="look-tagging">
            <span> {{ lookDetail.showTime }}</span>
        </div>
        <div :class="app === 'toumi' && managerId ? 'paddingBottom' : ''">
            <div id="content" class="look-main" v-html="lookDetail.content" @click="jump($event)"></div>
            <!-- 文章里的活动banner -->
            <div class="articleBanner" v-if="app === 'toumi' && lookDetail.recommendLocation === 1">
                <p :class="lookDetail.appInnerType === 0 ? 'activity' : ''" @click="jumpAd('banner')">{{ lookDetail.photoText }}</p>
            </div>
        </div>
        <div id="sideBanner" v-if="app === 'toumi' && lookDetail.recommendLocation === 0" :class="sideHide ? 'aside' : ''">
            <div class="sideClose" @click="hide()"></div>
            <p :class="lookDetail.photoText.length < 5 ? 'single' : ''" @click="showOrjump()">{{ lookDetail.photoText }}</p>
        </div>
        <!-- 分享按钮 -->
        <div class="share" v-if="app === 'toumi' && managerId">
            <a href="javascript: void(0)" class="shareBtn" @click="share">分享好友</a>
        </div>
    </div>
</template>
<script>
import sensors from "sa-sdk-javascript";
import { callHandler, bridgeRedirect } from "../../../utils/bridge";

export default {
    data() {
        return {
            lookDetail: {},
            userId: "",
            managerId: "",
            app: "",
            sideHide: false
        };
    },
    created() {
        let params = this.$route.query;
        const { id, token,version } = params;
        Promise.all([this.getContent(id, token, version), callHandler.bind(this)("xhAppUserInfo")]).then(res => {
            const { data } = res[0];
            this.lookDetail = data;
            const { userId, osType } = JSON.parse(res[1]);
            this.userId = userId;
            // 根据jsbridge返回的信息osType字段，是否包含"_Financial"字符串，来确定是不是理财师APP
            this.app = osType && osType.indexOf("_Financial") > -1 ? "planner" : "toumi";
        });
        this.getManageId(token);
    },
    mounted() {
        sensors.track("TMLookDetail");
    },
    updated() {
        const content = document.getElementById("content");
        const aLinks = content.getElementsByTagName("A");
        if (aLinks.length > 0) {
            for (let i = 0; i < aLinks.length; i++) {
                const aItem = aLinks[i];
                let href = aItem.getAttribute("href");
                // 齐欣保险
                if (this.isTarget(href)) {
                    if (href.indexOf("?") > -1) {
                        href += "&partnerUniqKey=" + this.userId;
                    } else {
                        href += "?partnerUniqKey=" + this.userId;
                    }
                    aItem.setAttribute("class", "jump");
                    aItem.setAttribute("href", "javascript:void(0)");
                    aItem.setAttribute("data-url", `${location.origin}${location.pathname}#/loadingXSBX?target=${encodeURIComponent(href)}`);
                }
                // 名阳保险
                if (href === "名阳保险") {
                    aItem.setAttribute("class", "mingyangJump");
                    aItem.setAttribute("href", "javascript:void(0)");
                }
            }
        }
    },
    methods: {
        getContent: function(id, token, version) {
            let sendData = { id: id,version: version };
            if (token) {
                sendData.token = token;
            }
            return this.$request({
                method: "post",
                url: `h5/gainuser/get`,
                data: this.$qs.stringify(sendData)
            });
        },
        isTarget(url) {
            const qixinHref = [
                "tuneapi.qixin18.com", //测试
                "cps.qixin18.com",
                "api.qixin18.com" //线上
            ];
            let result = false;
            for (let i of qixinHref) {
                if (url.indexOf(i) > -1) {
                    result = true;
                }
            }
            return result;
        },
        jump(event) {
            if (event.target.className === "jump") {
                const url = event.target.getAttribute("data-url");
                bridgeRedirect({
                    page: "webview",
                    pageParams: {
                        url: url,
                        login: "1"
                    }
                });
            }
            if (event.target.className === "mingyangJump") {
                // 根据理财师还是投米，调用不同的jsbridge
                if (this.app === "toumi") {
                    callHandler("xhH5OpenAppPage", {
                        ios: {
                            className: "TMMYInstranceListController"
                        },
                        android: {
                            packageName: "com.yixin.itoumi",
                            className: "com.creditease.tm.lender.finance.insurance.mingyang.InsuranceProductListActivity"
                        }
                    });
                } else {
                    callHandler("xhH5OpenAppPage", {
                        ios: {
                            className: "LCMingYInsuranceController"
                        },
                        android: {
                            packageName: "com.creditease.xinghuo",
                            className: "com.creditease.xinghuo.module.insurance.MingYangActivity"
                        }
                    });
                }
            }
        },
        jumpAd(position) {
            let { recommendLocation, photoText, jumpProductCode, appInnerType, jumpUrl, jumpProductId, jumpProductName, jumpProductType,title } = this.lookDetail;
            let simpleOpt = {
                recommendLocation,
                photoText,
                jumpProductCode,
                appInnerType,
                jumpUrl,
                jumpProductId,
                jumpProductName,
                jumpProductType
            };
            let click_location = position==='banner'?'内容底部':'侧边栏';
            // 神策埋点
            let sensorOpt = {
                page_source: '文章',
                page_name: title,
                click_location: click_location
            }
            if(appInnerType === 0){
                sensorOpt.enter_page = '输入地址';
            }else{
                switch (jumpProductType) {
                    case 1:
                        sensorOpt.enter_page = '嘉系列';
                        break;
                    case 2:
                        sensorOpt.enter_page = '类固收';
                        break;
                    case 3:
                        sensorOpt.enter_page = '私募股权';
                        break;
                    case 4:
                        sensorOpt.enter_page = '公募基金';
                        break;
                    case 5:
                        sensorOpt.enter_page = '齐欣保险';
                        break;
                    case 6:
                        sensorOpt.enter_page = '名阳保险';
                        break;
                    case 7:
                        sensorOpt.enter_page = '活期宝';
                        break;
                    case 8:
                        sensorOpt.enter_page = '目标盈';
                        break;
                    case 9:
                        sensorOpt.enter_page = '基金定投';
                        break;
                    case 10:
                        sensorOpt.enter_page = '地产基金';
                        break;
                    case 11:
                        sensorOpt.enter_page = '阳光私募';
                        break;
                    case 12:
                        sensorOpt.enter_page = '母基金';
                        break;
                }
            }
            sensors.track("TM_content_click",sensorOpt);
            callHandler("xhAdToProduct", simpleOpt);
        },
        hide() {
            this.sideHide = true;
        },
        showOrjump() {
            if (!this.sideHide) {
                this.jumpAd();
            } else {
                this.sideHide = false;
            }
        },
        getManageId(token) {
            (function(o) {
                o.$request({
                    method: "post",
                    url: `h5/user/queryUserManagerInfo.json`,
                    headers: {
                        "X-HUO-TM-H-PROGRAM": token
                    }
                }).then(function(data) {
                    if (data.code === "1") {
                        o.managerId = data.data.financeManagerId;
                    }
                });
            })(this);
        },
        share() {
            let params = this.$route.query;
            const { id } = params;
            let { shareContent, title, smallImage } = this.lookDetail;
            let origin = location.origin;
            let managerId = this.managerId;
            if (!managerId) {
                return callHandler("xhGoLoginPage");
            }
            if (origin === "https://www.itoumi.com") {
                origin = "https://www.xinghuo365.com";
            }
            let shareUrl = origin + `/h5static/app/planner/article.html?articleId=${id}&managerId=${managerId}&activityType=article&sourceType=toumi`;
            callHandler("xhShareSocialPlatform", {
                shareType: "all",
                shareTitle: title,
                shareContent: shareContent,
                shareImageUrl: smallImage,
                shareUrl: shareUrl,
                shareRemarks: shareContent
            });
        }
    }
};
</script>
<style lang="less">
.look-detail {
    width: 100%;
    background: #fff;
    border-radius: 20px;
    padding: 20px 16px;
    box-sizing: border-box;

    .look-title {
        font-size: 18px;
        font-weight: bold;
        color: #333333;
        line-height: 25px;
        margin-bottom: 12px;
    }
    .paddingBottom {
        padding-bottom: 90px;
    }
    .look-introducer {
        width: 100%;
        margin: 20px 0;
        background-image: linear-gradient(90deg, #fcfcfc 0%, #f8f8f8 100%);
        border-radius: 4px;
        padding: 12px 15px 12px 0px;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        span {
            white-space: nowrap;
            display: inline-block;
            padding: 0px 8px;
            text-align: center;
            height: 22px;
            line-height: 22px;
            font-size: 12px;
            color: #ffffff;
            border-radius: 0 20px 20px 0;
            margin-right: 12px;
            background-image: linear-gradient(90deg, #e0cb99 0%, #bd9c60 100%);
        }

        p {
            display: inline-block;
            font-size: 13px;
            color: #888888;
            line-height: 20px;
        }
    }

    .look-tagging {
        box-sizing: border-box;

        span {
            font-size: 13px;
            color: #aaaaaa;
            margin-right: 8px;
        }
    }

    .look-main {
        display: block;
        width: 100%;
        box-sizing: border-box;
        img {
            display: block !important;
            width: 100% !important;
        }

        section {
            display: block;

            max-width: 100%;
            box-sizing: border-box !important;
        }
    }
    .articleBanner {
        background: #ffffff;
        margin-top: 16px;
        padding: 16px;
        p {
            background: url("../../../assets/images/normal/bannerProduct.png") no-repeat;
            background-size: 343px 55px;
            height: 55px;
            text-indent: 75px;
            line-height: 55px;
            font-size: 13px;
            font-weight: bold;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &.activity {
                background: url("../../../assets/images/normal/bannerActivity.png") no-repeat;
                background-size: 343px 55px;
            }
        }
    }
    //文章的右侧浮动广告图
    #sideBanner {
        width: 75px;
        height: 104px;
        background: url("../../../assets/images/normal/activeBanner.png") no-repeat;
        background-size: 75px 104px;
        position: fixed;
        right: 0;
        top: 230px;
        box-sizing: border-box;
        padding-top: 42px;
        padding-left: 5px;
        padding-right: 5px;
        transition: right 0.5s linear;
        &.aside {
            right: -59px;
        }
        .sideClose {
            position: absolute;
            width: 30px;
            height: 30px;
            top: 0;
            right: 0;
            cursor: pointer;
        }
        p {
            font-size: 11px;
            color: #926e47;
            line-height: 13px;
            text-align: center;
            padding: 10px 8px 15px 8px;
            cursor: pointer;
            &.single {
                padding-top: 20px;
                padding-bottom: 20px;
            }
        }
    }
}
.share {
    padding: 9px 16px 16px 16px;
    background: #ffffff;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;

    a {
        display: block;
        height: 44px;
        line-height: 44px;
        background: linear-gradient(to right, #d0b77b 0%, #b89659 100%);
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        border-radius: 4px;
    }
}
</style>
